import { getDefined } from '../defined';

type UpdateUserArgs = {
  email?: string;
  abandonedCart: boolean;
};

export const useBeehiiv = () => {
  // TODO: The Beehiiv proxy URL
  // should be provided by the host application
  // to allow to control the target environment
  const BEEHIIV_URL = getDefined('PUBLIC_BEEHIIV_PROXY_SERVER_URL');

  const subscribeNewUser = async (email?: string) => {
    if (!BEEHIIV_URL)
      throw Error('Missing PUBLIC_BEEHIIV_PROXY_SERVER_URL env variable');

    if (!email) return;

    try {
      await fetch(BEEHIIV_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          utmSource: 'eliza',
        }),
      });
    } catch (e) {
      console.error({ status: 'user could not be subscribed', error: e });
    }
  };

  const updateUser = async ({ email, abandonedCart }: UpdateUserArgs) => {
    if (!BEEHIIV_URL)
      throw Error('Missing PUBLIC_BEEHIIV_PROXY_SERVER_URL env variable');

    if (!email) return;

    try {
      await fetch(BEEHIIV_URL, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          customFields: [{ name: 'abandonedCart', value: `${abandonedCart}` }],
        }),
      });
    } catch (e) {
      console.error({ status: 'user could not be updated', error: e });
    }
  };

  return { subscribeNewUser, updateUser };
};
